import { Outlet } from "react-router-dom";
import { DesktopSidebar } from "@/components/themeComponent/dashboard/SidebarContent";
import DashboardHeader from "@/components/themeComponent/dashboard/dashboardHeader";
import { SidebarProvider, useSidebar } from "@/components/app/SidebarContext";
import { useQuery } from "@tanstack/react-query";
import { authService } from "@/api/auth";
import { useAuthStore } from "@/store/useAuthStore";
import { useEffect } from "react";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { NotificationInitializer } from "@/components/app/NotificationInitializer";

import { useModuleTracker } from "@/hooks/useModuleTracker";

function DashboardContent() {
  useModuleTracker();
  const { collapsed, setCollapsed, collapsedByBtn } = useSidebar();
  const updateUserStore = useAuthStore((state) => state.updateUser);

  const { data: profileData } = useQuery({
    queryKey: ["manufacturer-profile"],
    queryFn: authService.getProfile,
    staleTime: 300000,
  });

  useEffect(() => {
    if (profileData?.data?.manufacturer) {
      updateUserStore(profileData.data.manufacturer);
    }
  }, [profileData, updateUserStore]);

  return (
    <div className=" bg-background">
      <NotificationInitializer />
      <div
        className={`hidden lg:block transition-[width] md:pl-5 md:py-5 bg-background top-0 bottom-0 left-0 fixed duration-300 ease-in-out h-full ${collapsed ? "w-[120px]" : "w-[310px]"}`}
        onMouseEnter={() => {
          if (collapsedByBtn) {
            setCollapsed(false);
          }
        }}
        onMouseLeave={() => {
          if (collapsedByBtn) {
            setCollapsed(true);
          }
        }}
      >
        <DesktopSidebar />
      </div>
      <div
        className={`relative transition-all duration-300 ease-in-out ${collapsed ? "lg:ml-[120px]" : "lg:ml-[310px]"}`}
      >
        <div className="md:px-5 sticky top-0 z-header w-full bg-background md:p-5 ">
          <div className="">
            <DashboardHeader />
          </div>
        </div>
        <main className="md:p-5 p-4 md:pt-0"><Outlet /></main>
      </div>
    </div>
  );
}

export default function DashboardLayout() {
  return (
    <ProtectedRoute>
      <SidebarProvider>
        <DashboardContent />
      </SidebarProvider>
    </ProtectedRoute>
  );
}
